import { IClassname } from '@/lib/shared/model/classname';

export const Golf = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.61041 15.5015C14.1854 15.5015 17.8913 17.1883 17.8913 19.2585C17.8913 21.3288 14.1598 23.0284 9.61041 23.0284C5.06103 23.0284 1.30396 21.3415 1.30396 19.2585C1.30396 18.3512 2.01959 17.5078 3.22083 16.8561"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9489 5.5466C12.0564 5.4939 12.147 5.41205 12.2103 5.31037C12.2735 5.2087 12.307 5.09129 12.3067 4.97153C12.3074 4.85006 12.2727 4.73102 12.2069 4.62892C12.1411 4.52681 12.047 4.44605 11.9361 4.39647L6.45386 1.94287V8.16633L11.9489 5.5466Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.45386 18.5048V8.1665"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8052 28.4597C12.8052 28.8834 12.9735 29.2897 13.273 29.5892C13.5726 29.8888 13.9789 30.0571 14.4026 30.0571C14.8262 30.0571 15.2325 29.8888 15.5321 29.5892C15.8317 29.2897 16 28.8834 16 28.4597C16 28.036 15.8317 27.6297 15.5321 27.3302C15.2325 27.0306 14.8262 26.8623 14.4026 26.8623C13.9789 26.8623 13.5726 27.0306 13.273 27.3302C12.9735 27.6297 12.8052 28.036 12.8052 28.4597Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6962 5.77686L23.8465 29.2138C23.7546 29.452 23.5936 29.6572 23.384 29.803C23.1745 29.9487 22.9261 30.0284 22.6708 30.0317H20.115C19.8801 29.9403 19.6654 29.8034 19.4834 29.629C19.3013 29.4546 19.1554 29.246 19.0539 29.0152C18.9525 28.7844 18.8975 28.5359 18.892 28.2838C18.8866 28.0318 18.9309 27.7811 19.0224 27.5462C19.2071 27.0717 19.5727 26.69 20.0389 26.4851C20.2697 26.3836 20.5182 26.3286 20.7703 26.3232C21.0223 26.3178 21.273 26.3621 21.5079 26.4535L24.3705 27.5014"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
